import React, { useState } from "react";
import { Typography } from "antd";
import { ITypographyProps, EFontWeights, IParagraphProps } from "./interface";
import { EColors } from "../ZColors/interface";
import styles from "./index.module.less";

const { Text, Paragraph } = Typography;

const ZText: React.FC<ITypographyProps> = ({
	level = 1,
	weight = EFontWeights.REGULAR,
	className = "",
	color = EColors.GRAY,
	colorVariant = 9,
	capitalise = false,
	children = "",
	...rest
}) => (
	<Text
		className={`font-${weight} text-${level} ${className} ${
			styles[`color-${color}-${colorVariant}`]
		}`}
		style={{
			whiteSpace: "pre-wrap",
			overflowWrap: "normal",
			...rest.style
		}}
		{...rest}
	>
		{capitalise && children && typeof children === "string"
			? children.toUpperCase()
			: children}
	</Text>
);

const ZTitle: React.FC<ITypographyProps> = ({
	children = "",
	className = "",
	...rest
}) => (
	<ZText
		className={`${styles.title} ${className} block`}
		level={4}
		weight={EFontWeights.MEDIUM}
		{...rest}
	>
		{children}
	</ZText>
);

const ZSectionHeading: React.FC<ITypographyProps> = ({
	children = "",
	className = "",
	...rest
}) => (
	<ZText
		level={2}
		className={`${styles.sectionHeading} ${className} block`}
		weight={EFontWeights.MEDIUM}
		{...rest}
	>
		{children}
	</ZText>
);

const ZSectionSubheading: React.FC<ITypographyProps> = ({
	children = "",
	className = "",
	...rest
}) => (
	<ZText
		level={0}
		colorVariant={7}
		className={`${styles.sectionSubheading} ${className} block`}
		{...rest}
	>
		{children}
	</ZText>
);

const ZLink: React.FC<ITypographyProps> = ({
	children = "",
	className = "",
	disabled = false,
	...rest
}) => (
	<ZText
		color={EColors.BLUE}
		colorVariant={6}
		className={`${styles.sectionSubheading} ${className} ${
			disabled ? "" : "cursor-pointer"
		}`}
		{...rest}
	>
		{children}
	</ZText>
);

const ZParagraph: React.FC<IParagraphProps> = ({
	level = 1,
	weight = EFontWeights.REGULAR,
	className = "",
	color = EColors.GRAY,
	colorVariant = 9,
	capitalise = false,
	children = "",
	collapsible = false,
	...rest
}) => {
	const [value, setValue] = useState(0);
	const [shouldShowViewLess, setShouldShowViewLess] = useState(false);

	const newEllipsis =
		typeof rest.ellipsis === "boolean" ||
		typeof rest.ellipsis === "undefined"
			? rest.ellipsis
			: {
					...rest.ellipsis,
					onExpand: (event: any) => {
						if (typeof rest.ellipsis === "object") {
							rest.ellipsis?.onExpand?.(event);
						}
						setShouldShowViewLess(true);
					}
			  };
	return (
		<Paragraph
			className={`font-${weight} text-${level} ${className} ${
				styles[`color-${color}-${colorVariant}`]
			}`}
			{...rest}
			key={value}
			ellipsis={newEllipsis}
		>
			{capitalise && children && typeof children === "string"
				? children.toUpperCase()
				: children}{" "}
			{collapsible && shouldShowViewLess && (
				<ZText
					className="cursor-pointer"
					color={EColors.BLUE}
					colorVariant={5}
					onClick={() => setValue(prev => prev + 1)}
				>
					View Less{" "}
				</ZText>
			)}
		</Paragraph>
	);
};

export { EFontWeights as FontWeights };

export default {
	ZText,
	ZTitle,
	ZSectionHeading,
	ZSectionSubheading,
	ZLink,
	ZParagraph
};
